import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { IPredictiveModelAction } from '../../spacesPlatform/models/actionNames';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { newPredictiveModelForDatasource } from '../actions/NewPredictiveModelForDatasourceAction';

export const NewPredictiveModelEntityAction: IEntityAction<IContentInfo<'datasource'>, IPredictiveModelAction> = {
  name: EntityActionNames.NewPredictiveModel,
  translateName: Messages.newPredictiveModel,
  isVisible: (targetItems: IContentInfo[]) => {
    // TODO: make this visible by uncommenting the line below after the alpha release
    // return FeatureFlags.prometheusPredictiveModelEnabled && !isSingleEmbeddedDatasource(targetItems);
    return false;
  },
  isClickable: (availableActions: IPredictiveModelAction, targetItems: IContentInfo[]) =>
      targetItems.length === 1 &&availableActions && availableActions.createPredictiveModel ,
  createReduxAction: (targetItems: IContentInfo[]) => {
    if (targetItems.length !== 1) {
      return;
    }

    const item = targetItems[0];
    if (item.contentType === 'datasource') {
      return newPredictiveModelForDatasource(item);
    }
  }
};
